module.exports = __webpack_public_path__ + "static/media/lighthouse-logo-optimized.fd849b7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/images/lighthouse-logo-optimized.png
// module id = 950
// module chunks = 0